import moment from 'moment';

class IndirectRateModalController {
  constructor($scope, $uibModalInstance, $rootScope, $http) {
    'ngInject';
    this.name = 'IndirectRateModal';

    $scope.isEdit = !!$uibModalInstance.isEdit;
    $scope.ratesLocked = $uibModalInstance.indirectRate ? !!$uibModalInstance.indirectRate.inUse : false;
    $scope.companyId = $uibModalInstance.companyId || 1;
    $scope.existingIndirectRates = $uibModalInstance.existingIndirectRates || [];
    $scope.errorMessage = '';

    $scope.opened = {};
    $scope.datePickerOptions = {
      formatYear: 'yy',
      startingDay: 1,
      showWeeks: false
    };
    $scope.datePickerFormat = 'MMM dd, yyyy';

    $scope.open = function ($event, elementOpened) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.opened[elementOpened] = !$scope.opened[elementOpened];
    };

    if ($uibModalInstance.indirectRate) {
      $scope.indirectRate = angular.copy($uibModalInstance.indirectRate);
      $scope.indirectRate.startDate = parseApiDate($scope.indirectRate.startDate);
      $scope.indirectRate.endDate = parseApiDate($scope.indirectRate.endDate);
    } else {
      $scope.indirectRate = {
        name: '',
        fringeRate: null,
        overheadRate: null,
        generalAdministrativeRate: null,
        subManagementRate: null,
        startDate: new Date(),
        endDate: null
      };
    }

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.getDateRangeConflict = function () {
      const rate = $scope.indirectRate;
      if (!rate.startDate || !rate.endDate) {
        return null;
      }

      const start = moment(rate.startDate).startOf('day');
      const end = moment(rate.endDate).startOf('day');
      if (!start.isValid() || !end.isValid() || end.isBefore(start)) {
        return null;
      }

      const conflicting = ($scope.existingIndirectRates || []).find(function (existing) {
        if ($scope.isEdit && rate.id && existing.id === rate.id) {
          return false;
        }
        if (!existing.startDate) {
          return false;
        }

        const existingStart = moment(existing.startDate).startOf('day');
        const existingEnd = existing.endDate
          ? moment(existing.endDate).startOf('day')
          : moment('9999-12-31');

        return start.isSameOrBefore(existingEnd) && existingStart.isSameOrBefore(end);
      });

      return conflicting || null;
    };

    $scope.save = function () {
      $scope.errorMessage = '';

      if (!$scope.isEdit && !$scope.indirectRate.endDate) {
        $scope.errorMessage = 'End date is required.';
        return;
      }

      if ($scope.indirectRate.endDate && moment($scope.indirectRate.endDate).isBefore(moment($scope.indirectRate.startDate), 'day')) {
        $scope.errorMessage = 'End date must be on or after the start date.';
        return;
      }

      const conflict = $scope.getDateRangeConflict();
      if (conflict) {
        $scope.errorMessage = 'Date range overlaps with "' + conflict.name + '" ('
          + formatDisplayDate(conflict.startDate) + ' – '
          + (conflict.endDate ? formatDisplayDate(conflict.endDate) : 'open') + ').';
        return;
      }

      const payload = buildPayload($scope.indirectRate);
      const url = $rootScope.apiHost + '/api/admin/companies/' + $scope.companyId + '/indirectrates';
      const request = $scope.isEdit
        ? $http.put(url + '/' + $scope.indirectRate.id, payload, { withCredentials: true })
        : $http.post(url, payload, { withCredentials: true });

      request.then(function () {
        $uibModalInstance.success();
      }, function (failure) {
        $scope.errorMessage = getErrorMessage(failure);
      });
    };

    $scope.missingRequiredValues = function () {
      const rate = $scope.indirectRate;
      if (!rate.name || !rate.startDate) {
        return true;
      }

      if (!$scope.isEdit && !rate.endDate) {
        return true;
      }

      if (rate.endDate && moment(rate.endDate).isBefore(moment(rate.startDate), 'day')) {
        return true;
      }

      if ($scope.getDateRangeConflict()) {
        return true;
      }

      return [rate.fringeRate, rate.overheadRate, rate.generalAdministrativeRate, rate.subManagementRate]
        .some(function (value) {
          return value == null || value === '';
        });
    };
  }
}

function parseApiDate(value) {
  if (!value) {
    return null;
  }
  const parsed = moment(value);
  return parsed.isValid() ? parsed.toDate() : null;
}

function formatApiDate(value) {
  if (!value) {
    return null;
  }
  return moment(value).format('YYYY-MM-DD');
}

function formatDisplayDate(value) {
  if (!value) {
    return '—';
  }
  return moment(value).format('MMM DD, YYYY');
}

function buildPayload(rate) {
  return {
    name: rate.name,
    fringeRate: Number(rate.fringeRate),
    overheadRate: Number(rate.overheadRate),
    generalAdministrativeRate: Number(rate.generalAdministrativeRate),
    subManagementRate: Number(rate.subManagementRate),
    startDate: formatApiDate(rate.startDate),
    endDate: formatApiDate(rate.endDate)
  };
}

function getErrorMessage(failure) {
  if (failure && failure.data) {
    if (failure.data.message) {
      return failure.data.message;
    }
    if (typeof failure.data === 'string') {
      return failure.data;
    }
  }
  return 'Could not save indirect rate.';
}

export default IndirectRateModalController;



// WEBPACK FOOTER //
// ./client/common/modals/indirectRateModal/indirectRateModal.controller.js